import Alert from '@mui/material/Alert';
import { FindCanopyButton } from "./CanopyButtons.js";
import { CanopyCutawayLocationButton } from "./CutawayInputs.js";
import './i18n/config';
import { useTranslation, Trans } from 'react-i18next';

export function CanopyReleaseLocationAlert(props: any) {
    const { show = false, ...rest } = props;
    const { t } = useTranslation();
    if (!show) {
        return (<></>)
    } else {
        return (<>
            <Alert severity="info" className="alert-overlay">
                {t("alerts.click_to_set_location")}
            </Alert>
        </>)
    }
}

export function ReleaseLocationNotSetAlert(props: any) {
    const { show = false, onShowCanopySearch = () => { }, onSetCutawayLocation = () => { }, ...rest } = props;
    const { t } = useTranslation();
    if (!show) {
        return (<></>)
    } else {
        return (<>
            <Alert severity="error" className="alert-overlay">
                {t("alerts.release_location_not_set")} 
                    <FindCanopyButton onClick={onShowCanopySearch}></FindCanopyButton> 
                    {t("alerts.release_location_not_set_part2")}
                    <CanopyCutawayLocationButton onClick={onSetCutawayLocation}></CanopyCutawayLocationButton>
            </Alert>
        </>)
    }
}